import React, { useEffect } from "react";
import { Container, Row, Col, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Footer.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { getSocialmedia } from "../../features/socialmedia/Slice";
import { appSetup } from "../../features/master/masterSlice";

const Footer = () => {
  const socialmedia = useSelector((state) => state.socialmedia.addSocialmedia);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSocialmedia());
  }, [dispatch]);
  const appsetup = useSelector((state) => state.master.app_setup);

  useEffect(() => {
    dispatch(appSetup());
  }, [dispatch]);

  return (
    <footer className="footer">
      <div className="custom_container">
        <div className="bg_div">
          <div className="logo_div">
            <img src="/assets/Images/footer/logo.png" className="logo_img" />
          </div>

          <Nav className="footer-nav">
            <Nav.Link as={Link} to="/home">
              Home
            </Nav.Link>
            <Nav.Link as={Link} to="/about">
              About us
            </Nav.Link>
            <Nav.Link as={Link} to="/careers">
              Careers
            </Nav.Link>
            <Nav.Link as={Link} to="/blog">
              Blog
            </Nav.Link>
            <Nav.Link as={Link} to="/contact">
              Contact Us
            </Nav.Link>
            <Nav.Link as={Link} to="/faq">
              FAQ
            </Nav.Link>
            <Nav.Link as={Link} to="/account-setting">
              My Account
            </Nav.Link>
          </Nav>

          <div className="footer_location_holder">

            <div className="bottom_div">
              <Nav className="bottom_nav">
                <Nav.Link as={Link} to="/privacy-policy">
                  Privacy Policy
                </Nav.Link>
                <Nav.Link as={Link} to="/return-policy">
                  Return Policy
                </Nav.Link>
                <Nav.Link as={Link} to="/terms">
                  Terms & Conditions
                </Nav.Link>
              </Nav>
            </div>

            <div className="footer-social ">
              <p>Follow Us:</p>
              {socialmedia?.map((item, index) => (
                <Link key={index} to={item.url} target="_blank">
                  <img
                    src={process.env.REACT_APP_IMG_URL + item.image}
                    alt="social-icon"
                    width="30"
                    height="30"
                    className="social_icon"
                  />
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>

      <p className="copy_text">
        Copyright &copy; 2025 All Rights Reserved. Developed by{" "}
        <Link to={"https://profcymaglobal.com/"} target="_black">
          Profcyma
        </Link>
        .
      </p>
    </footer>
  );
};

export default Footer;
